import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useConfirmCommonResult = () => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Failed to confirm result");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ ids }) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/healthlink/common/message/status/bulk`,
        {
          ids: ids,
          status: "CONFIRMED",
        }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Common results confirmed successfully!");
      queryClient.invalidateQueries({ queryKey: ["staffCommonResults"] });
      queryClient.invalidateQueries({ queryKey: ["unmatchedStaffCommonResults"] });
    },
    onError: handleNetworkError,
    // Show only this specific toast — opt out of the global MutationCache handler.
    meta: { skipGlobalError: true },
  });
};
